import * as React from 'react';
import { Button } from '../ui/button';
import { cn } from '../../lib/utils';

export interface EmptyStateProps {
  title?: string;
  description?: string;
  icon?: React.ReactNode;
  action?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
}

export const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ title, description, icon, action, className }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'flex flex-col items-center justify-center gap-4 py-12 px-4 text-center',
          className,
        )}
      >
        {icon && (
          <div className="flex items-center justify-center rounded-lg bg-[var(--color-muted)] p-3">
            <div className="h-8 w-8 text-[var(--color-muted-foreground)]">
              {icon}
            </div>
          </div>
        )}

        {title && (
          <h3 className="text-lg font-semibold text-[var(--color-foreground)]">
            {title}
          </h3>
        )}

        {description && (
          <p className="max-w-sm text-sm text-[var(--color-muted-foreground)]">
            {description}
          </p>
        )}

        {action && (
          <Button onClick={action.onClick} className="mt-2">
            {action.label}
          </Button>
        )}
      </div>
    );
  },
);

EmptyState.displayName = 'EmptyState';
